import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div id="contact">
            <h3 className="text-white text-xl font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3 text-gray-300">
              <p className="flex items-center">
                <span className="font-medium mr-2">Phone:</span>
                <a
                  href="tel:+919930351241"
                  className="text-blue-600 hover:underline"
                >
                  +91 9930351241
                </a>
              </p>
              <p className="flex items-center">
                <span className="font-medium mr-2">Email:</span>
                <a
                  href="mailto:newideainvestment05@gmail.com"
                  className="text-blue-600 hover:underline"
                >
                  newideainvestment05@gmail.com
                </a>
              </p>
              <p className="flex items-center">
                <span className="font-medium mr-2">Address:</span>
                Panvel, Navi Mumbai
              </p>
            </div>
          </div>
          <div>
            <h3 className="text-white text-xl font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-300 hover:text-white transition duration-150 ease-in-out">
                  Home
                </a>
              </li>
              <li>
                <a href="/scanner" className="text-gray-300 hover:text-white transition duration-150 ease-in-out">
                  Scan QR
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-300 hover:text-white transition duration-150 ease-in-out">
                  Our Services
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-gray-800 pt-8">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} SN Advisor. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 